// Simple password strength validator migrated from mockData usage

export const validatePasswordStrength = (password) => {
  const requirements = {
    minLength: password.length >= 8,
    hasLowercase: /[a-z]/.test(password),
    hasUppercase: /[A-Z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecialChar: /[^a-zA-Z\d]/.test(password)
  };

  const score = Object.values(requirements).filter(Boolean).length;
  let strength = 'weak';
  if (score >= 4) strength = 'strong';
  else if (score >= 3) strength = 'medium';

  const feedback = [];
  if (!requirements.minLength) feedback.push('at least 8 characters');
  if (!requirements.hasLowercase) feedback.push('a lowercase letter');
  if (!requirements.hasUppercase) feedback.push('an uppercase letter');
  if (!requirements.hasNumber) feedback.push('a number');
  if (!requirements.hasSpecialChar) feedback.push('a special character');

  return {
    strength,
    score,
    requirements,
    feedback,
    isValid: score >= 3
  };
};

export default { validatePasswordStrength };


